import React, {useMemo} from "react";
import {TextField} from "@mui/material";
import {SelectField} from "@atttomyx/react-components";
import {arrays, forms, objects} from "@atttomyx/shared-utils";
import {LABEL_ANY, LABEL_NONE} from "../../constants";
import "./nodeFilters.css";

const NodeFilters = (props) => {
    const { formProps, data, onChange : onSync } = props;
    const { unique } = formProps;

    const phones = useMemo(() => {
        const array = arrays.copy(unique.phones);
        arrays.prependTo(array, LABEL_NONE);
        arrays.prependTo(array, LABEL_ANY);
        return array;
    }, [unique.phones]);

    const emails = useMemo(() => {
        const array = arrays.copy(unique.emails);
        arrays.prependTo(array, LABEL_NONE);
        arrays.prependTo(array, LABEL_ANY);
        return array;
    }, [unique.emails]);

    const urls = useMemo(() => {
        const array = arrays.copy(unique.urls);
        arrays.prependTo(array, LABEL_NONE);
        arrays.prependTo(array, LABEL_ANY);
        return array;
    }, [unique.urls]);

    const addresses = useMemo(() => {
        const array = arrays.copy(unique.addresses);
        arrays.prependTo(array, LABEL_NONE);
        arrays.prependTo(array, LABEL_ANY);
        return array;
    }, [unique.addresses]);

    const dates = useMemo(() => {
        const array = arrays.copy(unique.dates);
        arrays.prependTo(array, LABEL_NONE);
        arrays.prependTo(array, LABEL_ANY);
        return array;
    }, [unique.dates]);

    const others = useMemo(() => {
        const array = arrays.copy(unique.others);
        arrays.prependTo(array, LABEL_NONE);
        arrays.prependTo(array, LABEL_ANY);
        return array;
    }, [unique.others]);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="node-filters">
        <div className="cards">
            <div className="card">
                <div className="field">
                    <TextField
                        label="First Name"
                        type="text"
                        value={forms.sanitizeValue(data.firstName)}
                        onChange={(event) => onChange("firstName", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Last Name"
                        type="text"
                        value={forms.sanitizeValue(data.lastName)}
                        onChange={(event) => onChange("lastName", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Phone"
                        type="text"
                        value={forms.sanitizeValue(data.phone)}
                        onChange={(event) => onChange("phone", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Email"
                        type="text"
                        value={forms.sanitizeValue(data.email)}
                        onChange={(event) => onChange("email", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="URL"
                        type="text"
                        value={forms.sanitizeValue(data.url)}
                        onChange={(event) => onChange("url", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Date"
                        type="text"
                        value={forms.sanitizeValue(data.date)}
                        onChange={(event) => onChange("date", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Other"
                        type="text"
                        value={forms.sanitizeValue(data.other)}
                        onChange={(event) => onChange("other", event.target.value)}
                    />
                </div>
            </div>
            <div className="card">
                <div className="field">
                    <SelectField
                        label="Has Address"
                        value={forms.sanitizeValue(data.addressExists)}
                        onChange={(value) => onChange("addressExists", value)}
                        options={addresses}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Line 1"
                        type="text"
                        value={forms.sanitizeValue(data.line1)}
                        onChange={(event) => onChange("line1", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Line 2"
                        type="text"
                        value={forms.sanitizeValue(data.line2)}
                        onChange={(event) => onChange("line2", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="City"
                        type="text"
                        value={forms.sanitizeValue(data.locality)}
                        onChange={(event) => onChange("locality", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="State"
                        type="text"
                        value={forms.sanitizeValue(data.region)}
                        onChange={(event) => onChange("region", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Postal Code"
                        type="text"
                        value={forms.sanitizeValue(data.postalCode)}
                        onChange={(event) => onChange("postalCode", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Country"
                        type="text"
                        value={forms.sanitizeValue(data.country)}
                        onChange={(event) => onChange("country", event.target.value)}
                    />
                </div>
            </div>
            <div className="card">
                <div className="field">
                    <SelectField
                        label="Has Phone"
                        value={forms.sanitizeValue(data.phoneExists)}
                        onChange={(value) => onChange("phoneExists", value)}
                        options={phones}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Has Email"
                        value={forms.sanitizeValue(data.emailExists)}
                        onChange={(value) => onChange("emailExists", value)}
                        options={emails}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Has URL"
                        value={forms.sanitizeValue(data.urlExists)}
                        onChange={(value) => onChange("urlExists", value)}
                        options={urls}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Has Date"
                        value={forms.sanitizeValue(data.dateExists)}
                        onChange={(value) => onChange("dateExists", value)}
                        options={dates}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Has Other"
                        value={forms.sanitizeValue(data.otherExists)}
                        onChange={(value) => onChange("otherExists", value)}
                        options={others}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Has Tag"
                        value={forms.sanitizeValue(data.tagHas)}
                        onChange={(value) => onChange("tagHas", value)}
                        options={unique.tags}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Does not have Tag"
                        value={forms.sanitizeValue(data.tagNot)}
                        onChange={(value) => onChange("tagNot", value)}
                        options={unique.tags}
                    />
                </div>
            </div>
        </div>
    </div>
}

export default NodeFilters;
